export const REGISTRATION_FIELDS = [
  'name',
  'email',
  'password',
  'age',
  'age_checkbox',
];

export const VALIDATION_MESSAGES = {
  name_missing: 'Укажите имя',
  email_invalid: 'Введите корректный email',
  password_short: 'Пароль должен содержать минимум 6 символов',
  age_invalid: 'Укажите возраст от 18 до 120 лет',
  age_checkbox_missing: 'Подтвердите, что вам уже исполнилось 18 лет',
};

export const collectRegistrationErrors = ({
  name,
  email,
  password,
  age,
  ageConfirmed,
}) => {
  const errors = [];
  if (!String(name || '').trim()) errors.push({ fieldName: 'name', validationCode: 'name_missing' });
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim())) {
    errors.push({ fieldName: 'email', validationCode: 'email_invalid' });
  }
  if (String(password || '').length < 6) errors.push({ fieldName: 'password', validationCode: 'password_short' });
  if (!Number.isInteger(Number(age)) || Number(age) < 18 || Number(age) > 120) errors.push({ fieldName: 'age', validationCode: 'age_invalid' });
  if (!ageConfirmed) errors.push({ fieldName: 'age_checkbox', validationCode: 'age_checkbox_missing' });
  return errors;
};

export const fieldIsComplete = (fieldName, value) => {
  if (fieldName === 'name') return Boolean(String(value || '').trim());
  if (fieldName === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  if (fieldName === 'password') return String(value || '').length >= 6;
  if (fieldName === 'age') return Number.isInteger(Number(value)) && Number(value) >= 18 && Number(value) <= 120;
  if (fieldName === 'age_checkbox') return value === true;
  return false;
};
